import _isNil from "lodash/isNil";
import './index.css';
import { Spinner } from '@datacamp/campus-integration';
import { useAreFeatureFlagsLoaded } from '@datacamp/exercise-feature-flags';
import { CollapsedSidebar, InstructionPane, InstructionsPlaceholder } from '@datacamp/exercise-instruction-pane';
import { constants } from '@datacamp/explorable-exercise-core';
import { SolutionContext } from '@datacamp/input-fields';
import { Multiplexer } from '@datacamp/multiplexer-integration';
import ResizableElements, { CollapseContext } from '@datacamp/waffles-resizable-elements';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { ProvidedSolutionContext } from '../../containers/ProvidedSolutionContext';
import { sentry } from '../../lib/sentry';
import { AnswerPanel } from '../AnswerPanel';
import InteractivePane from '../InteractivePane';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Exercise = _ref => {
  var _exercise$runtime_con;
  let {
    checkExercise,
    environment,
    exercise,
    exerciseId,
    onExerciseFinished,
    onExerciseStatusUpdate,
    showExercise,
    showSolution,
    updateLostXp,
    user
  } = _ref;
  const {
    t
  } = useTranslation('glossary');
  const [currentId, setCurrentId] = React.useState(undefined);
  const [newOutputs, setNewOutputs] = React.useState([]);
  if (currentId !== exerciseId) {
    setCurrentId(exerciseId);
    setNewOutputs([]);
  }
  React.useEffect(() => {
    showExercise();
  }, [exerciseId, showExercise]);
  const areFeatureFlagsLoaded = useAreFeatureFlagsLoaded();
  const onCheckExercise = React.useCallback((message, success, submittedCode) => {
    setNewOutputs([{
      correct: success,
      message
    }]);
    checkExercise(message, success, submittedCode);
  }, [checkExercise]);
  const onContinue = () => !_isNil(exercise) && onExerciseFinished({
    id: exerciseId
  });
  const onError = React.useCallback((error, extra) => {
    sentry.captureError(error, extra);
  }, []);
  if (!areFeatureFlagsLoaded) {
    return ___EmotionJSX(Spinner, null);
  }
  const multiplexerExercise = (exercise === null || exercise === void 0 ? void 0 : exercise.question.flavor) === 'MultipleChoice' || (exercise === null || exercise === void 0 ? void 0 : exercise.question.flavor) === 'Open' ? {
    courseId: exercise.course_id,
    id: exerciseId,
    language: exercise.language,
    preExerciseCode: exercise.question.pre_exercise_code,
    runtimeConfig: (_exercise$runtime_con = exercise.runtime_config) !== null && _exercise$runtime_con !== void 0 ? _exercise$runtime_con : '',
    sampleCode: '',
    sct: (exercise === null || exercise === void 0 ? void 0 : exercise.question.flavor) === 'MultipleChoice' ? exercise.question.sct : '',
    solution: ''
  } : undefined;
  return ___EmotionJSX("div", {
    className: "explorable-exercise"
  }, ___EmotionJSX(Multiplexer, {
    checkExercise: onCheckExercise,
    environment: environment,
    exercise: multiplexerExercise,
    onExerciseStatusUpdate: onExerciseStatusUpdate,
    type: constants.exercises.EXPLORABLE_EXERCISE,
    user: user
  }, ___EmotionJSX(ProvidedSolutionContext, {
    exercise: exercise,
    exerciseId: exerciseId
  }, ___EmotionJSX(ResizableElements, {
    collapsedSize: 36.5,
    initialProportions: [40, 60],
    orientation: "row"
  }, ___EmotionJSX(CollapseContext.Consumer, null, _ref2 => {
    let {
      collapsedFirstElement,
      toggleFirstElement
    } = _ref2;
    return (
      // eslint-disable-next-line no-nested-ternary
      collapsedFirstElement ? ___EmotionJSX(CollapsedSidebar, {
        className: "dc-panel exercise__sidebar",
        onClick: toggleFirstElement
      }) : exercise === undefined || user === undefined ? ___EmotionJSX(InstructionsPlaceholder, {
        subHeadingText: "Exercise"
      }) : ___EmotionJSX(React.Fragment, null, ___EmotionJSX(SolutionContext.Consumer, null, _ref3 => {
        let {
          hasSolution
        } = _ref3;
        return ___EmotionJSX(InstructionPane, {
          assignment: exercise.assignment,
          environment: environment,
          exerciseId: exerciseId,
          exerciseSubtitle: t('exercise', {
            count: 1
          }),
          hint: exercise.hint,
          instructionSubtitle: t('instruction', {
            count: 2
          }),
          isLoggedIn: user.isLoggedIn,
          isRatingPermitted: exercise.isRatingPermitted,
          newOutputs: newOutputs,
          onClickCollapse: toggleFirstElement,
          onContinue: onContinue,
          onError: onError,
          onTakeHint: undefined,
          onTakeSolution: hasSolution ? showSolution : undefined,
          onUpdateXp: updateLostXp,
          padBottom: true,
          solutionMessage: undefined,
          title: exercise.title,
          xp: exercise.xp
        }, ___EmotionJSX(AnswerPanel, {
          checkExercise: onCheckExercise,
          exercise: exercise,
          exerciseId: exerciseId
        }));
      }))
    );
  }), ___EmotionJSX(InteractivePane, {
    exercise: exercise
  })))));
};
export default Exercise;